import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class ThankyouPageViewedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.ThankyouPageViewed;

  getPayload(): any {
    return {
      date: Date.now()
    };
  }
}
